/** @format */
import React, {
	useEffect,
	useState,
	useContext,
	memo,
	useLayoutEffect,
	useMemo,
	useRef
} from 'react';
import {
	Link,
	__RouterContext,
	withRouter,
	useLocation,
	useHistory
} from 'react-router-dom';
import { getAPILanguage, getLocalStorageLng } from 'utils/utils';
import { AuthContext } from 'context/auth';
import { Trans } from 'react-i18next';

const Deeplink = () => {
	const { isLoggedIn, setLoading, loading, getToken } = useContext(AuthContext);
	const localizedLang = getLocalStorageLng();
	const location = useLocation();
	const history = useHistory();
	let defaultUrl;
	let tmpPathname;
	let memberPathname;

	defaultUrl = 'eatgether://eatgether.com' + location.pathname;

	tmpPathname = location.pathname.substring(1);
	var absoluteURL = tmpPathname;
	var splittedStr = absoluteURL.split('/');
	var finalUrl = `${splittedStr[splittedStr.length - 2]}/${
		splittedStr[splittedStr.length - 1]
	}`;

	if (finalUrl === '') {
		finalUrl = 'meetups';
	}
	if (location.pathname == `/${localizedLang}/` || location.pathname == `/`) {
		defaultUrl = 'eatgether://meetups';
	} else if (location.pathname == `/${localizedLang}/redeems`) {
		defaultUrl = 'eatgether://redeems';
	} else {
		defaultUrl = 'eatgether://' + finalUrl;
	}

	const downloadRedirect = () => {
		let userAgent = window.navigator.userAgent,
			platform = window.navigator.platform,
			macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
			windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
			iosPlatforms = ['iPhone', 'iPad', 'iPod'];

		if (macosPlatforms.indexOf(platform) !== -1) {
			history.push(`/${localizedLang}/download`);
		} else if (iosPlatforms.indexOf(platform) !== -1) {
			iOSOpenApp(defaultUrl);
		} else if (windowsPlatforms.indexOf(platform) !== -1) {
			history.push(`/${localizedLang}/download`);
		} else if (/Android/.test(userAgent)) {
			AndroidOpenApp(defaultUrl);
		} else if (/Linux/.test(platform)) {
			history.push(`/${localizedLang}/download`);
		}
	};

	const InitLinkRedirect = (detectUrl) => {
		let userAgent = window.navigator.userAgent,
			platform = window.navigator.platform,
			macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'],
			windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'],
			iosPlatforms = ['iPhone', 'iPad', 'iPod'];

		if (macosPlatforms.indexOf(platform) !== -1) {
		} else if (iosPlatforms.indexOf(platform) !== -1) {
			iOSOpenApp(detectUrl);
		} else if (windowsPlatforms.indexOf(platform) !== -1) {
		} else if (/Android/.test(userAgent)) {
			AndroidOpenApp(detectUrl);
		} else if (/Linux/.test(platform)) {
		}
	};

	function DeepLinkConfig(options) {
		if (!options) {
			throw new Error('no options');
		}

		var hasFocus = true;
		var didHide = false;

		function onBlur() {
			hasFocus = false;
		}

		function onVisibilityChange(e) {
			if (e.target.visibilityState === 'hidden') {
				didHide = true;
			}
		}

		function onFocus() {
			if (didHide) {
				if (options.onReturn) {
					options.onReturn();
				}

				didHide = false; // reset
			} else {
				if (!hasFocus && options.onFallback) {
					setTimeout(function () {
						if (!didHide) {
							options.onFallback();
						}
					}, 1000);
				}
			}

			hasFocus = true;
		}

		function bindEvents(mode) {
			[
				[window, 'blur', onBlur],
				[document, 'visibilitychange', onVisibilityChange],
				[window, 'focus', onFocus]
			].forEach(function (conf) {
				conf[0][mode + 'EventListener'](conf[1], conf[2]);
			});
		}

		bindEvents('add');

		this.destroy = bindEvents.bind(null, 'remove');
		this.openURL = function (url) {
			var dialogTimeout = 500;

			setTimeout(function () {
				if (hasFocus && options.onIgnored) {
					options.onIgnored();
				}
			}, dialogTimeout);

			window.location = url;
		};
	}

	const AndroidOpenApp = (detectUrl) => {
		let before = new Date().valueOf();
		setTimeout(function () {
			let after = new Date().valueOf();
			if (after - before > 200) {
				return;
			}
			window.location = 'https://goo.gl/tmZ59c';
		}, 250);
		window.location = detectUrl;
	};

	const iOSOpenApp = (customUrl) => {
		var url = customUrl;
		var badURL = 'https://goo.gl/MPdHNW';

		var linker = new DeepLinkConfig({
			onIgnored: function () {
				console.log('browser failed to respond to the deep link');
				// window.location = 'https://goo.gl/MPdHNW'
			},
			onFallback: function () {
				// window.location = 'https://goo.gl/MPdHNW'
				// console.log('dialog hidden or user returned to tab')
			},
			onReturn: function () {
				console.log('user returned to the page from the native app');
			}
		});

		linker.openURL(url);
	};

	useEffect(() => {
		InitLinkRedirect(defaultUrl);
	}, [defaultUrl]);

	return (
		<>
			<section
				className="is-hidden-tablet"
				style={{
					background: 'white',
					width: '100%',
					height: '52px',
					position: 'fixed',
					zIndex: '10'
				}}>
				<div style={{ margin: 'auto' }}>
					<div className="container has-text-centered">
						<hr style={{ marginBottom: 0, marginTop: 0 }} />
						<div className="columns is-mobile">
							<div className="column is-2">
								<img
									src="https://eatgether.files.wordpress.com/2017/10/cropped-logo.png?w=200"
									style={{ width: 100, marginLeft: 10 }}
									alt=""
								/>
							</div>
							<div className="column is-10 has-text-left">
								<h1
									className="subtitle has-text-black is-6"
									style={{ marginBottom: 5, marginTop: 5 }}>
									Eatgether
								</h1>
								<p
									className="subtitle has-text-black is-7"
									style={{ marginTop: 0 }}>
									<Trans i18nKey="deeplink.title"></Trans>
								</p>
							</div>
						</div>
					</div>
				</div>
				<div
					className="media-right"
					style={{ position: 'absolute', right: 20, top: 15 }}>
					<span className="has-text-link" onClick={downloadRedirect}>
						<Trans i18nKey="deeplink.open"></Trans>
					</span>
				</div>
				<hr style={{ marginBottom: 0, marginTop: 0 }} />
			</section>
			<div className="is-hidden-tablet" style={{ height: '50px' }}></div>
		</>
	);
};

export default Deeplink;
